import './style.scss';
import { Box, Typography } from '@mui/material';
import { useLanguageContext } from '../../../../../contexts/LanguageContext';
import ScrollableX from '../../../../../components/ScrollableX';
import Card from '../../../../../components/Card';


interface IHotelsProps {
    items: any[];
    home?: boolean;
    onClick?: (item: any) => void;
}


const Hotels: React.FC<IHotelsProps> = ({
    items,
    home = false,
    onClick = undefined
}) => {
    const { translate } = useLanguageContext();


    return <Box className='grid-content-section' id='hotels'>
        <Typography variant='subtitle1' className='hotels-title'>{translate(home ? 'hotelsTitleHome' : 'hotelsTitle')}</Typography>
        <Typography variant='subtitle2' className='hotels-description'>{translate(home ? 'hotelsDescriptionHome' : 'hotelsDescription')}</Typography>

        <Box className='hotels-items'>
            <ScrollableX hasContainer={false}>
                {
                    items.map((r, index) => {
                        return <Card 
                            chip={translate(r.type)}
                            image={r.wallpaper}
                            title={r.name}
                            variant='wallpaper'
                            key={index}
                            Icon={r.Icon}
                            className='width-lg'
                            onClick={() => onClick?.(r)}
                        />;
                    })
                }
            </ScrollableX>
        </Box>
    </Box>;
}

export default Hotels;